import StateTransitionAction from '@/ecm/models/workflow/StateTransitionAction'
import Utils from '@/ecm/common/Utils'
export default class StateTransition {
    constructor (dto) {
        this.uuid = Utils.object.getUUID()
        this.stateTo = 0
        this.transitionType = 'V'
        this.digitalSignatureConfigId = ''
        this.conditionStr = ''
        this.displayConditionStr = ''
        this.roleTypeIDs = []
        this.actions = []

        if (dto) {
            this.stateTo = dto.StateTo
            this.transitionType = dto.TransitionType
            this.digitalSignatureConfigId = dto.DigitalSignatureConfigID + ''
            this.conditionStr = dto.ConditionStr
            this.displayConditionStr = dto.DisplayConditionStr
            this.roleTypeIDs = dto.RoleTypeIDs.map(x => x + '')
            this.actions = dto.Actions.map(function (dto) { return new StateTransitionAction(dto) })
        }
    }

    toDto () {
        return {
            StateTo: this.stateTo,
            TransitionType: this.transitionType,
            DigitalSignatureConfigID: this.digitalSignatureConfigId,
            ConditionStr: this.conditionStr,
            RoleTypeIDs: this.roleTypeIDs.map(x => parseInt(x)),
            Actions: this.actions.map(x => x.toDto()),
        }
    }
}
